export default "__VITE_ASSET__4953684c__"